import React from 'react'
import {
  IssueContainer,
  InnerIssueContainer,
  MainContent,
  IssueTitle,
  SidebarP,
  Sidebar,
  SidebarHeader,
  SidebarSubheader,
  CloseButton
} from '.'

interface Props {
  handleClose: () => void
}

export default function ImmigrationCard({ handleClose }: Props) {
  return (
    <IssueContainer>
      <InnerIssueContainer>
        <MainContent>
          <IssueTitle>Building a Welcoming America</IssueTitle>
          <SidebarP>
            Over the past year, our district has seen ICE agents target our neighbors in schools, at the grocery store, and in their own
            driveways. This district needs an elected official who stands in solidarity with immigrant and refugee communities, not a
            representative who votes to militarize the border and funds Trump’s deportation machine. Justin will join the movement to
            Abolish ICE and build a immigration process accountable to human rights standards by restructuring through the Justice and State
            Departments. Justin will fight to shut down facilities that profit from detaining immigrants and refugees and work to
            demilitarize the border. The immigration enforcement industry has created jobs for thousands of families, Justin will focus on
            developing alternative employment opportunities and focus on long term workforce development.
          </SidebarP>
          <SidebarP>
            Justin believes in ensuring due process for all people from students, construction workers, farmworkers, asylum seekers,
            refugees and the countless others who strengthen the US. Justin is with the majority of America in supporting paths to
            citizenship.
          </SidebarP>
        </MainContent>
        <Sidebar>
          {/* <SidebarHeader>JUSTIN SUPPORTS</SidebarHeader>
          <SidebarSubheader href="https://www.congress.gov/bill/116th-congress/house-bill/2415/all-info">
            HR 2415 - Dignity for Detained Immigrants Act
          </SidebarSubheader>
          <SidebarP>Justin will join 137 co-sponsors, including Representative Steve Cohen (TN-05).</SidebarP> */}
          <SidebarHeader>RESOURCES</SidebarHeader>
          <SidebarSubheader href="https://www.prri.org/spotlight/not-even-reddest-states-support-deportation-robert-p-jones-atlantic/">
            Not Even the Reddest States Support Deportation
          </SidebarSubheader>
          <SidebarSubheader href="https://www.tennessean.com/story/money/2017/02/21/study-immigrants-vital-tennessee-economy/98200076/">
            Immigrants Help Fuel Tennessee Economy and Workforce
          </SidebarSubheader>
          <SidebarSubheader href="https://www.ice.gov/features/history">History of ICE</SidebarSubheader>
        </Sidebar>
      </InnerIssueContainer>
      <CloseButton onClick={handleClose}>CLOSE</CloseButton>
    </IssueContainer>
  )
}
